import { GALLERIES, POOLS } from "../types";

export const GalleriesReducer = (state = [], action) => {
	const { type, payload } = action;

	switch (type) {
		case GALLERIES: {
			const { data } = payload;
			state = [];
			return data;
		}
		default: {
			return state;
		}
	}
};
